import type { FeatureCollection } from 'geojson';
import { fetchJson } from '../lib/fetchJson';

/** Texas Hill Country watershed basins via the same-origin proxy (no CORS upstream). */
export function fetchHillCountry(signal?: AbortSignal): Promise<FeatureCollection> {
  return fetchJson<FeatureCollection>('/api/hill-country', { signal, timeoutMs: 60_000 });
}
